/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelQuikqAsset.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/quikq-asset";

export class AutogenModelQuikqAsset<RowType extends ModelRow> extends Endpoint<RowType, RowQuikqAssetFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowQuikqAsset extends ModelRow<RowQuikqAssetFields> {
	constructor(values?: Partial<RowQuikqAssetFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowQuikqAssetFields {
	asset_id: string;
	asset_type: string;
	company_id: string;
	first_name: string;
	last_name: string;
	last_update_date: Date;
	last_update_user: string;
	master_id: string;
	start_code: string;
	status: string;
}

